import React, { useEffect } from "react";

import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

import GlobalModal from "components/GlobalModal";

import Router from "routes/Router";
import { RootState } from "store/configureStore";

import useAnalytics from "hooks/useAnalytics";
import AnalyticsManager from "components/Analytics/AnalyticsManager";

import { closeNotification } from "store/features/notificationSlice";
import { useAppDispatch, useAppSelector } from "store/hooks";

import "dayjs/locale/uk";
import dayjs from "dayjs";

import "assets/styles/index.scss";

const App: React.FC = () => {
  useEffect(() => {
    dayjs.locale("uk");
  }, []);

  useAnalytics();

  const dispatch = useAppDispatch();
  const { open, message, severity } = useAppSelector(
    (state: RootState) => state.notification
  );

  const handleClose = () => {
    dispatch(closeNotification());
  };

  return (
    <>
      <AnalyticsManager />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
      >
        <Alert data-testid="alert" severity={severity} sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>
      <GlobalModal />
      <Router />
    </>
  );
};

export default App;
